import React from "react";

/**
 * BotFace — nav "Bot" glyph: rounded capsule with two dash eyes.
 *
 * ponytail: hand-drawn to match the Figma nav reference — no stock icon in
 * react-icons has this shape (Tabler's robot/robot-face carry antennae, limbs
 * and a mouth). Geometry/stroke follow Tabler's conventions so it sits evenly
 * beside its siblings. Swap for the real export once the Figma icon set is
 * pulled (Icon System V.2.0.0, file LedlgNlwu4pXBMmGmAr6op).
 */
export default function BotFace(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <rect x="2.5" y="6" width="19" height="12" rx="5.5" />
      <path d="M9 12h1.5" />
      <path d="M13.5 12h1.5" />
    </svg>
  );
}
